"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGEXP_FLIGHT_NUMBER = exports.REGEXP_FLIGHT_NUMBER_FORMAT = void 0;
exports.parseFlightNumber = parseFlightNumber;
exports.isFlightNumber = isFlightNumber;
exports.containsFlightNumber = containsFlightNumber;
exports.REGEXP_FLIGHT_NUMBER_FORMAT = /([0-9A-Z][A-Z]|[A-Z][0-9A-Z]{0,1}|[A-Z]{3}|[A-Z0-9]{2}[A-Z])[\s-]?(\d{1,4}[A-Z]?)/;
exports.REGEXP_FLIGHT_NUMBER = new RegExp(`^${exports.REGEXP_FLIGHT_NUMBER_FORMAT.source}$`);
function parseFlightNumber(flightNumber) {
    const cleanedFlightNumber = flightNumber.toUpperCase().trim();
    // extract carrier code and flight number
    const match = cleanedFlightNumber.match(exports.REGEXP_FLIGHT_NUMBER);
    if (!match) {
        return null;
    }
    return {
        carrierCode: match[1],
        flightNumberOnly: match[2],
    };
}
function isFlightNumber(value) {
    return exports.REGEXP_FLIGHT_NUMBER.test(value);
}
function containsFlightNumber(value) {
    return exports.REGEXP_FLIGHT_NUMBER_FORMAT.test(value);
}
//# sourceMappingURL=flight-number.js.map